import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { User, AuthenticationService } from '@csx/security';
import { DomSanitizer } from '@angular/platform-browser';
import { PollService } from '../services/poll.service';

@Component({
  selector: 'app-browser',
  templateUrl: './browser-support.component.html',
  styleUrls: ['./browser-support.component.scss']
})
export class BrowserSupportComponent implements OnInit {
  ngOnInit() {}

  returnOfflineSupportedBrowserName() {
    if ('userAgent' in navigator) {
      if (navigator.userAgent.search('iPhone') > -1 || navigator.userAgent.search('iPad') > -1) {
        return 'Safari';
      } else {
        return 'Chrome';
      }
    } else {
      return 'Supported';
    }
  }
}
